// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities: '7#Задача#Задачи#Задач',
    Activities_Text: '7#{0} Активность#{0} Активности#{0} Активностей',
    activities_without_dates: 'Активности без дат',
    Activity: 'Активность',
    Activity_Billing: 'Биллинг',
    Activity_Cost: 'Биллинг активности',
    Activity_CostVariance: 'Отклонение от бюджета',
    Activity_HoursLeft: 'осталось',
    Activity_InternalCost: 'Факт. стоимость',
    Activity_Profit: 'Прибыль',
    Add_Task: 'Добавить задачу',
    AITaskGeneration_projectName: 'Имя',
    AITaskGeneration_retry: 'Повторить попытку',
    AITaskGeneration_title: 'Добавление плана проекта с помощью ИИ',
    All_Saved_Views: 'Все сохраненные виды',
    Apply_Text: 'Применить',
    apply_wbs_sorting: 'Применить сортировку по WBS',
    Archive_Success_Message: 'Проект \"{0}\" был заархивирован',
    archived_label: '(в архиве)',
    Baseline_Text: 'Базовый план',
    batch_info_all_checked: 'Выбраны родительская и все дочерние активности',
    batch_info_only_parent_checked: 'Выбрана только родительская активность',
    batch_info_sub_tasks_checked: 'Выбраны только дочерние активности, родительская не выбрана',
    batch_info_title: 'Иконки пакетных операций:',
    Board_CreateTaskInProjectPlaceholder: 'Создать в проекте',
    Board_ShowMore: 'Показать еще',
    Browse_Views: 'Посмотреть все виды',
    Budget_problem_project: 'Факт. стоимость превышает общий бюджет',
    Budget_problem_task: 'Факт. трудозатраты превышают общий бюджет',
    Budget_Text: 'Бюджет',
    Budget_warning_project: 'Ожидаемая итоговая стоимость превышает общий бюджет',
    Budget_warning_task: 'EAC трудозатраты превышают общий бюджет',
    change_activity_type_to_label: 'Изменить тип активности на',
    ChooseTemplateDropdownLabel: 'Создать проект на основе существующего шаблона',
    Counter: 'Количество Проектов/Задач',
    CPI_Problem: 'CPI ниже порогового значения',
    Create: 'Создать',
    create_snapshot: 'Снимки проектов',
    CreateNewItem: 'Начни печатать, чтобы создать новый проект или активность...',
    CreateProject_Tooltip: 'Создать новый проект',
    CriticalPath_Text: 'Критический путь',
    CustomField_No: 'Нет',
    CustomField_Yes: 'Да',
    DayPluralFormat: '7#День#Дня#Дней',
    Default_Text: 'По умолчанию',
    Delete_Confirmation_Title: 'Удалить выбранные объекты',
    Delete_Entity_Confirmation_Archive_Description: '<b>Вместо удаления проекта вы можете заархивировать его и восстановить, когда понадобится.</b>',
    Delete_Project_Title: 'Удалить проект \"{0}\" (ID {1})?',
    Delete_Task_Title: 'Удалить активность \"{0}\" (ID {1})?',
    Delete_Text: 'Удалить',
    DeleteEntityConfirmation: 'включая все тайм-логи, сообщения и прикрепленные файлы {0}. Операцию нельзя будет отменить!',
    DeletePermanently: 'Удалить навсегда',
    DeleteVerb: '7#будет удален навсегда#будут удалены навсегда#будут удалены навсегда',
    DeleteVerbActivity: '7#будет удалена навсегда#будут удалены навсегда#будут удалены навсегда',
    Dependency_AddMore_Text: 'Добавить зависимости',
    Dependency_Cancel: 'Отмена',
    Dependency_Choose: 'Выберите задачу или введите ключевое слово...',
    Dependency_days: 'дня',
    Dependency_DelayWarningExample: 'Пример: -34, 42',
    Dependency_DelayWarningText: 'Введите числа от -1000 до 1000',
    Dependency_DependencyCycle: 'Создание зависимости с выбранной задачей невозможно, поскольку возникает ситуация, когда мастер-задача зависит от зависимой задачи.',
    Dependency_DependencyType_Text: 'Тип зависимости',
    Dependency_DependsOn_Text: 'Зависит от',
    Dependency_FinishToStart_Minus1: 'Задача начинается за день до завершения {0}',
    Dependency_FinishToStart_Minus1_Pattern: 'Задача начинается <b>за день</b> до завершения \"{0}\"',
    Dependency_FinishToStart_Minus2: 'Задача начинается за {1} до завершения {0}',
    Dependency_FinishToStart_Minus2_Pattern: 'Задача начинается <b>за {1}</b> до завершения \"{0}\"',
    Dependency_FinishToStart_Plus0: 'Задача начинается в день завершения {0} ',
    Dependency_FinishToStart_Plus0_Pattern: 'Задача начинается <b>в день</b> завершения \"{0}\"',
    Dependency_FinishToStart_Plus1: 'Задача начинается на следующий день после завершения {0}',
    Dependency_FinishToStart_Plus1_Pattern: 'Задача начинается <b>на следующий день</b> после завершения \"{0}\"',
    Dependency_FinishToStart_Plus2: 'Задача начинается через {1} после завершения {0}',
    Dependency_FinishToStart_Plus2_Pattern: 'Задача начинается <b>через {1}</b> после завершения \"{0}\"',
    Dependency_FinishWhenStarted_Text: 'Задача завершится, когда начнется \"{0}\"',
    Dependency_FinishWhenStarted_Title: 'Завершение по началу',
    Dependency_Lag_Text: 'Лаг',
    Dependency_ParentChildRelationship: 'Создание зависимости невозможно, поскольку одна из задач является родительской, а другая – дочерней (подзадачей).',
    Dependency_Reason: 'Причина',
    Dependency_Remove_Text: 'Удалить',
    Dependency_RemoveSingleDependency_Text: 'Удалить зависимость',
    Dependency_Save: 'Сохранить',
    Dependency_SelectDependsOn_Text: 'Выберите Зависит от',
    Dependency_StartsWhenFinished_Text: 'Задача начнется, когда завершится \"{0}\"',
    Dependency_StartsWhenFinished_Title: 'Начало  по завершению',
    Dependency_StartsWhenStarted_Text: 'Задача начнется, когда начнется \"{0}\"',
    Dependency_StartsWhenStarted_Title: 'Начало по началу',
    Dependency_StartToFinish_Minus1: 'Задача завершается за день до начала {0}',
    Dependency_StartToFinish_Minus1_Pattern: 'Задача завершается <b>за день</b> до начала \"{0}\"',
    Dependency_StartToFinish_Minus2: 'Задача завершается за {1} до начала {0}',
    Dependency_StartToFinish_Minus2_Pattern: 'Задача завершается <b>за {1}</b> до начала \"{0}\"',
    Dependency_StartToFinish_Plus0: 'Задача завершается в день начала {0}',
    Dependency_StartToFinish_Plus0_Pattern: 'Задача завершается <b>в день</b> начала \"{0}\"',
    Dependency_StartToFinish_Plus1: 'Задача завершается на следующий день после начала {0}',
    Dependency_StartToFinish_Plus1_Pattern: 'Задача завершается <b>на следующий день</b> после начала \"{0}\"',
    Dependency_StartToFinish_Plus2: 'Задача завершается через {1} после начала {0}',
    Dependency_StartToFinish_Plus2_Pattern: 'Задача завершается <b>через {1}</b> после начала \"{0}\"',
    Dependency_StartToStart_Minus1: 'Задача начинается за день до начала {0}',
    Dependency_StartToStart_Minus1_Pattern: 'Задача начинается <b>за день</b> до начала \"{0}\"',
    Dependency_StartToStart_Minus2: 'Задача начинается за {1} до начала {0}',
    Dependency_StartToStart_Minus2_Pattern: 'Задача начинается <b>за {1}</b> до начала \"{0}\"',
    Dependency_StartToStart_Plus0: 'Задача начинается в день начала {0} ',
    Dependency_StartToStart_Plus0_Pattern: 'Задача начинается <b>в день начала</b> \"{0}\"',
    Dependency_StartToStart_Plus1: 'Задача начинается на следующий день после начала {0}',
    Dependency_StartToStart_Plus1_Pattern: 'Задача начинается <b>на следующий день</b> после начала \"{0}\"',
    Dependency_StartToStart_Plus2: 'Задача начинается через {1} после начала {0}',
    Dependency_StartToStart_Plus2_Pattern: 'Задача начинается <b>через {1}</b> после начала \"{0}\"',
    Dependency_Warning_Text: 'Операция не может быть завершена.',
    Details: 'Детали',
    Edit_Text: 'Редактировать',
    empty_sorting_list: 'Параметры сортировки не найдены',
    EnterProjectName: 'Введите название проекта',
    EnterTaskName: 'Введите название задачи',
    EnterViewName_Text: 'Введите название вида',
    Error_DragAndDrop_BreakingHierarchy: 'Задача не может быть дочерней для собственной подзадачи.',
    Error_DragAndDrop_ChangeParentInFlattenView: 'Измените вид с плоского на иерархический, чтобы изменить иерархию задач.',
    Error_DragAndDrop_CycleDependencies: 'Данная операция создаст циклическую зависимость (т.е. Задача А зависит от Задачи Б, а Задача Б зависит от Задачи А).',
    Error_DragAndDrop_DifferentProjects: 'Нельзя переместить задачу в другой проект (используйте детали задачи).',
    Error_DragAndDrop_ReorderWithSorting: 'Изменение порядка задач возможно только при включенной опции сортировки WBS по возрастанию.',
    EstimatedHours_problem: 'Тайм-логи превышают расчетные часы',
    export_activities: 'Aктивности',
    export_activities_expanded_only: 'Активности (Только развернутые)',
    Export_Activities_Text: 'Экспорт Активностей в CSV',
    Export_Import_Text: 'Экспорт и Импорт',
    export_projects: 'Проекты',
    Export_Projects_Text: 'Экспорт Проектов в CSV',
    flat_view: 'Плоский вид',
    From: 'из',
    Group_By_Portfolio: 'Группировать по портфолио',
    group_by_project: 'Группировать по проекту',
    Hide_Counter: 'Скрыть количество Проектов/Задач',
    Hide_Text: 'Спрятать',
    hide_uncategorized_tasks: 'Скрыть активности, не соответствующие ни одному календарю',
    Hours_Short_Text: 'ч',
    Import_CSV_Text: 'Импорт из CSV',
    Import_MSProject_Text: 'Импортировать из MS Project',
    Import_Text: 'Импортировать',
    Indicator_Counter_Snooze_Tooltip: '1#У {0} элемента есть проблемы#У {0} элементов есть проблемы',
    Indicator_Counter_Tooltip: 'Количество активностей с риском',
    Indicator_Project_Tooltip: 'Метрики проекта, требующие внимания:',
    Indicator_Snooze_1_Week: 'На 1 неделю',
    Indicator_Snooze_4_Hours: 'На 4 часа',
    Indicator_Snooze_Cancel: 'Отменить',
    Indicator_Snooze_Custom: 'До выбранной даты',
    Indicator_Snooze_Custom_Modal_Header: 'Отложить индикацию до',
    Indicator_Snooze_Forever: 'Навсегда',
    Indicator_Snooze_Menu_Text: 'Отложить индикацию проблем',
    Indicator_Snooze_Message: 'Индикация проблем отложена для вас до {0}.',
    Indicator_Snooze_Message_Forever: 'Индикация проблем отложена для вас навсегда.',
    Indicator_Snooze_Until_Tomorrow: 'До завтра',
    Indicator_Task_Tooltip: 'Метрики активности, требующие внимания:',
    Learn_More_Text: 'Подробнее',
    Loading_Text: 'Загрузка данных...',
    More_Tasks: 'Еще {0}',
    MoreActions_AddActivity: 'Добавить активность',
    MoreActions_AddAIActivities: 'Добавить план проекта с помощью ИИ',
    MoreActions_AddNextActivity: 'Добавить след. активность',
    MoreActions_AddSubActivity: 'Добавить подзадачу',
    MoreActions_SaveProjectAsTemplate: 'Сохранить как шаблон',
    MoreActions_SetAsMilestone: 'Пометить вехой',
    MoreActions_UnsetAsMilestone: 'Убрать пометку вехой',
    My_Presets: 'Мои',
    My_Text: 'Мой',
    MyPresetName_Text: 'Мой',
    NewProject: 'Новый проект',
    NewProjectBasedOn: 'Новый проект на основе {0}',
    NewTask: 'Новая задача',
    no_custom_field_value_label: 'н/д',
    No_Portfolio: 'Без Портфолио',
    no_project_custom_fields_created_text: 'Нет созданных настраиваемых полей проекта',
    No_Templates_Text: 'Шаблоны не найдены.',
    NoSavedViews_Text: 'Нет сохраненных видов.',
    Of: 'из',
    old_sort_az: 'А→Я',
    old_sort_za: 'Я→А',
    parent_activities: 'Родительские активности',
    Portfolios_Text: '7#{0} Портфолио#{0} Портфолио#{0} Портфолио',
    preset_delete: 'Удалить вид',
    preset_delete_confirmation: 'Удалить сохраненный вид \"{0}\"?',
    preset_rename: 'Переименовать вид',
    preset_save: 'Сохранить вид',
    preset_saveAs: 'Сохранить вид как',
    preset_share: 'Открыть всем в этом рабочем пространстве',
    preset_unshare_confirmation: 'Закрыть для всех вид {0}?',
    Project: 'Проект',
    Project_ActualBudgetProfitability: 'Фактическая рентабельность бюджета',
    Project_BudgetedCost: 'Общий бюджет',
    Project_CostVariance: 'Отклонение от бюджета',
    Project_EstimatedBudgetProfitability: 'Ожидаемая рентабельность бюджета',
    Project_Expenses: 'Расходы',
    project_info: 'Информация о Проекте',
    Project_InternalCost: 'Факт. стоимость',
    Project_ProjectBilling: 'Биллинг проекта',
    Project_ProjectProfit: 'Прибыль проекта',
    Project_ProjectProfitability: 'Прибыльность',
    ProjectArchive: 'Проект (в архиве)',
    ProjectEndDate_problem: 'Проект не выполнен в установленный срок',
    Projects: '7#Проект#Проекта#Проектов',
    Projects_Text: '7#{0} Проект#{0} Проекта#{0} Проектов',
    Rename_Text: 'Переименовать',
    Restore_Text: 'Восстановить',
    Save_Text: 'Сохранить',
    SaveAs_Text: 'Сохранить как',
    Share_Text: 'Открыть всем',
    Shared_With_Me: 'Доступные мне виды',
    show_archived_projects: 'Архив проектов',
    Show_Text: 'Показать',
    SortBy_Text: 'Сортировать по',
    SPI_Problem: 'SPI ниже порогового значения',
    SubActivities: '7#Подзадача#Подзадачи#Подзадач',
    switchToClassicUI: 'Переключиться на старый вид',
    switchToNewUI: 'Переключиться на новый вид',
    tab_Board: 'Доска',
    tab_Calendar: 'Календарь',
    tab_Gantt: 'Гант',
    tab_Table: 'Таблица',
    TargetProfit_warning: 'Целевая прибыль проекта меньше, чем ожидаемая прибыль',
    TargetProfitPercentage_warning: 'Целевая прибыль проекта (%) меньше, чем ожидаемая прибыль (%)',
    TaskEndDate_problem: 'Задача не выполнена в установленный срок',
    TaskEndDate_warning: 'Задача завершается позже родителя',
    TaskStartDate_warning: 'Задача начинается раньше родителя',
    Templates_Popup_Title: 'На основе шаблона:',
    TimerText: '7#{0} секунда#{0} секунды#{0} секунд',
    Tools_Menu_Text: 'Инструменты',
    Tooltip_DefaultPresetIcon: 'Выбор или управление сохраненными видами',
    Tooltip_RevertToDefaultPreset: 'Вернуться к виду по умолчанию',
    Tooltip_SaveDefaultPreset: 'Сохранить выбранные фильтры и другие настройки как новый вид',
    Tooltip_SharedByMePreset: 'Доступен всем',
    TotalTargetRevenue_warning: 'ПОПЗ выручка меньше, чем общая выручка проекта',
    Unarchive_Success_Message: 'Проект \"{0}\" был разархивирован.',
    uncategorized_tasks: 'Активности без календарей',
    Unshare_Text: 'Закрыть для всех',
    View_Project_Link: 'Показать проект',
    what_to_export: 'Что экспортировать?',
};
